<template>
    <el-container class="contain">
      <el-aside>
        <div class="logo" style="margin: auto 0px;text-align: center;padding-top: 10px">
          <img v-if="!isCollapse" src="../../assets/logo1.png" alt="" width="155px" height="45px" style="transition: all .5s linear">
          <img v-else="!isCollapse" src="../../assets/logo2.png" alt="" width="25px" height="25px">
        </div>
        <Navbar></Navbar>
      </el-aside>
      <el-main>
        <el-header>
          <Header></Header>
        </el-header>
        <div style="border-top:1px solid #f0f2f5;min-height: 100%;width:100%">
          <router-view></router-view>
        </div>
        <div v-if="nameFlag" style="float:left; width: 100%;text-align: center;margin-top: 0px;height: 80px;line-height: 80px;font-size: 13px;color: #6f7180">
        copyright &copy; 2018 成都嘉逸科技有限公司 荣誉出品</div>
        <div v-else style="float:left; width: 100%;text-align: center;margin-top: 0px;height: 80px;line-height: 80px;font-size: 13px;color: #6f7180">
          copyright &copy; 2018 四川智康科技有限责任公司 荣誉出品</div>
      </el-main>
    </el-container>
</template>

<script>
import Header from './Header'
import Navbar from '@/components/layout/Navbar'
import host from '../../mixins/host.js'
export default {
    name: 'container',
    mixins: [host],
    data () {
        return {
          isCollapse: false,
          showNotice: false
        }
    },
    methods: {
      handleNotice() {
        this.showNotice = !this.showNotice
      }
    },
    components: {
        Header,
        Navbar
    },
    computed:{
      getNavSta(){
        return this.$store.getters.getNavState
      }
    },
    watch:{
      getNavSta(val){
        this.isCollapse=val
      }
  }
}
</script>

<style scoped lang='less'>
    .contain{
      height:100%;
      width: 100%;
      .el-aside{
        height:100%;
        background:#001224;
        /*width:255px !important;*/
        width: auto !important;
        /*max-width: 255px !important;*/
        .logo{
          height:64px;
          line-height: 64px;
        }
      }
        .el-header{
            padding:0;
            height:200px;
        }
        .el-main{
            padding:0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/layout/index.vue